import {makeAutoObservable, toJS} from "mobx";

class NumStore {

    roomInfo = {}
    nowPpl = 0;
    constructor() {
        makeAutoObservable(this)
    }

    setRoomInfo(data) {
        this.roomInfo = {
            ...data
        }
        this.nowPpl = this.roomInfo['stMin'];
    }

    getRoomInfo() {
        return toJS(this.roomInfo)
    }

    getNowppl() {
        return toJS(this.nowPpl)
    }

    addPeople(max) {
        if(this.nowPpl >= max) return;
        this.nowPpl += 1;
    }

    subtractPeople(min) {
        if(this.nowPpl <= min) return;
        this.nowPpl -= 1;
    }

    initValue() {
        this.roomInfo = {}
        this.nowPpl = 0;
    }

}

let numStore = new NumStore()
export default numStore